<script lang="ts">
  import { onMount, afterUpdate, onDestroy } from "svelte"
  import { RiCustomerServiceFill } from "svelte-remixicon"
  import { browser } from "$app/environment"
  import { setBackgroundColor, zoomLink } from "$lib/utils"

  export let showHelp = false
  export let title = "Commune AI"
  export let background = "#29243D"
  export let noLogo = false

  onMount(() => setBackgroundColor(background))
  afterUpdate(() => setBackgroundColor(background))
  onDestroy(() => setBackgroundColor("initial"))
</script>

<svelte:head>
  <title>
    {title}
  </title>
</svelte:head>

{#key title}
  <div class="banner min-h-screen text-white-ai" style:background-color={background}>
    <div class="content relative z-10">
      <a href="/" data-sveltekit-reload class="fixed text-2xl tracking-wide user-select-none top-5 left-7">
        <span class="font-bold">COMMUNE</span> AI
      </a>
    
      <div class="container mx-auto py-12 px-6 flex flex-col min-h-screen gap-6 justify-start pt-40">
        <div class="mx-auto">
          <h1 class="title font-display text-title-smaller lg:text-title max-w-screen-md mb-8 text-center select-none whitespace-pre-line">
            {title}
          </h1>
      
          <div class="form-container-ai">
            <slot />
          </div>
        </div>
      </div>

      {#if !noLogo}
        <a href="https://www.interrobang-performance.com/" class="fixed bottom-0 left-0 w-24 m-7 animate__jello animate__repeat-2" >
          <img src="/logo.png"  alt="Interrobang?! Performance">
        </a>
      {/if}
    </div>

    <div class="fixed inset-0 z-0">
      <slot name="background-content"/>
    </div>

    {#if showHelp}
      <a href={zoomLink} class="fixed right-0 bottom-0 z-10 flex items-center gap-2 cursor-pointer hover:underline p-6">
        <RiCustomerServiceFill class="inline w-8 h-8" fill="white" /> <p>Need help?<br>Click for support</p>
      </a>
    {/if}
  </div>
{/key}
